module.exports = __webpack_public_path__ + "f34a8bf4feb15f45a1c06324d998d45c.png";